import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Редактировать")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Отмена")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    title: `${_ctx.disabledEdit ? 'Дата создания:' : 'Добавить встречу'} ${
      _ctx.result?.meet
        ? _ctx.moment
            .utc(_ctx.result.meet?.createdAt)
            .utcOffset(-240)
            .format('YYYY-MM-DD HH:mm')
        : ''
    }`,
    visible: "",
    onCancel: _ctx.handleCancel
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "submit",
        onClick: _ctx.handleCancel
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        key: "back",
        type: "primary",
        onClick: _ctx.handleOk,
        disabled: _ctx.disabledEdit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.meetId ? "Сохранить" : "Создать"), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    default: _withCtx(() => [
      (_ctx.createError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_a_alert, {
              type: "error",
              message: "Ошибка сохранения"
            }),
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_form, _mergeProps({
        ref: "formRef",
        model: _ctx.formState,
        rules: _ctx.rules
      }, _ctx.layout), {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "Дата",
            "has-feedback": "",
            name: "time"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_date_picker, {
                value: _ctx.formState.time,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.time) = $event)),
                "show-time": "",
                format: "YYYY-MM-DD HH:mm",
                "value-format": "YYYY-MM-DD HH:mm",
                disabled: _ctx.disabledEdit,
                locale: _ctx.locale
              }, null, 8, ["value", "disabled", "locale"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "Улица",
            "has-feedback": "",
            name: "street",
            rules: [{ required: true, message: 'Укажите улицу' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.street,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.street) = $event)),
                autocomplete: "off",
                disabled: _ctx.disabledEdit
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "Дом",
            "has-feedback": "",
            name: "house",
            rules: [{ required: true, message: 'Укажите дом' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.house,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.house) = $event)),
                autocomplete: "off",
                disabled: _ctx.disabledEdit
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "Квартира",
            "has-feedback": "",
            name: "apartment"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.apartment,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.apartment) = $event)),
                autocomplete: "off",
                disabled: _ctx.disabledEdit
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "Подстройка",
            "has-feedback": "",
            name: "adjustment"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_switch, {
                checked: _ctx.formState.adjustment,
                "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.adjustment) = $event)),
                disabled: _ctx.disabledEdit
              }, null, 8, ["checked", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "hunter",
            label: "Агент",
            "has-feedback": "",
            rules: [{ required: true, message: 'Пожалуйста выберите агента' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.formState.hunter,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.hunter) = $event)),
                disabled: _ctx.disabledEdit
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agents, ({ id, lastName }) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: id,
                      value: id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(lastName), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "manager",
            label: "Менеджер",
            "has-feedback": "",
            rules: [{ required: true, message: 'Пожалуйста выберите менеджера' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.formState.manager,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.manager) = $event)),
                disabled: _ctx.disabledEdit
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.managers, ({ id, lastName }) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: id,
                      value: id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(lastName), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "Тип встречи",
            "has-feedback": "",
            name: "type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                ref: "select",
                value: _ctx.formState.type,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.type) = $event)),
                style: {"width":"100%"},
                options: _ctx.types,
                disabled: _ctx.disabledEdit
              }, null, 8, ["value", "options", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "РП",
            "has-feedback": "",
            name: "source"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                ref: "select",
                value: _ctx.formState.source,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.source) = $event)),
                style: {"width":"100%"},
                options: _ctx.sources,
                disabled: _ctx.disabledEdit
              }, null, 8, ["value", "options", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "Результат",
            "has-feedback": "",
            name: "result"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                ref: "select",
                value: _ctx.formState.result,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formState.result) = $event)),
                style: {"width":"100%"},
                options: 
            ['Встреча', 'Встреча с ключами'].includes(_ctx.formState.type)
              ? _ctx.resultsMeet
              : _ctx.resultsOther
          ,
                disabled: _ctx.disabledEdit
              }, null, 8, ["value", "options", "disabled"])
            ]),
            _: 1
          }),
          (
          _ctx.formState.result === 'Отмена' &&
          ['Встреча', 'Встреча с ключами'].includes(_ctx.formState.type)
        )
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 0,
                label: "Причина отмены",
                "has-feedback": "",
                name: "cancelReason",
                rules: [{ required: true, message: 'Пожалуйста выберите причину' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    ref: "select",
                    value: _ctx.formState.cancelReason,
                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formState.cancelReason) = $event)),
                    style: {"width":"100%"},
                    options: _ctx.cancelReasons,
                    disabled: _ctx.disabledEdit
                  }, null, 8, ["value", "options", "disabled"])
                ]),
                _: 1
              }))
            : (_ctx.formState.result === 'Отмена')
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 1,
                  label: "Причина отмены",
                  "has-feedback": "",
                  name: "cancelReason",
                  rules: [{ required: true, message: 'Пожалуйста выберите причину' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formState.cancelReason,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formState.cancelReason) = $event)),
                      autocomplete: "off",
                      disabled: _ctx.disabledEdit
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
          _createVNode(_component_a_form_item, {
            label: "Примечание",
            "has-feedback": "",
            name: "note"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.note,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formState.note) = $event)),
                autocomplete: "off",
                disabled: _ctx.disabledEdit
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }),
          (_ctx.meetId)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 2,
                onClick: _ctx.enabledEdit
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 16, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "onCancel"]))
}